import {useParams} from 'react-router-dom';

import {usePermissions} from '@dms/shared';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function IntegrationWidgetsSubSection() {
  const {id: vehicleIdParam} = useParams();
  const [canReadBusinessCase] = usePermissions({permissionKeys: ['businessCaseRead']});

  const vehicleId = vehicleIdParam ?? '';

  return (
    <VFKit.SubSection data-testid="cebia-widgets">
      <VFKit.ShowWhen when={canReadBusinessCase}>
        <VFKit.Suspense>
          <VFKit.CebiaAutotracerWidget vehicleId={vehicleId} />
          <VFKit.CebiaProductionYearWidget vehicleId={vehicleId} />
        </VFKit.Suspense>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
